import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { Link } from '@shared/componentsStyled/Link'
import styled, { CSSObject } from 'styled-components'

export function SectionProtected() {
	return (
		<Section>
			<ViewRoot>
				<TextTitle>Ваши деньги под защитой</TextTitle>
				<ViewRow>
					<ViewItem>
						<ImageStyled name='investProtected1.png' alt='' />
						<Text>
							Вся сумма сбережений направляется на выдачу займов под залог ликвидных квартир, что
							обеспечивает защиту ваших денег. Стоимость залога более чем в 2 раза превышает сумму
							выданных займов
						</Text>
					</ViewItem>
					<ViewItem>
						<ImageStyled name='investProtected2.png' alt='' />
						<Text>
							Предусмотрен компенсационный фонд СРО на 24 млн рублей и собственный резервный фонд на
							5% от суммы сбережений для дополнительной защиты клиентов
						</Text>
					</ViewItem>
					<ViewItem last>
						<ImageStyled name='investProtected3.png' alt='' />
						<Text>
							Работаем под надзором Банка России и Ассоциации СРО «НОКК»
							<br />
							<Link
								href='https://www.cbr.ru/finorg/foinfo/?ogrn=1196658040677'
								target='_blank'
								rel='noopener noreferrer nofollow'
							>
								Реестр ЦБ
							</Link>
						</Text>
					</ViewItem>
				</ViewRow>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	marginBottom: 60,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const ViewRow = styled.div(
	({ theme }) =>
		({
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'flex-start',
			[theme.mediaQueries.mediaMinWidthMobile]: {
				flexDirection: 'row',
				justifyContent: 'space-between',
			},
		} as CSSObject)
)

interface ViewItemProps {
	last?: boolean
}

const ViewItem = styled.div<ViewItemProps>(({ theme, last = false }) => ({
	flex: 1,
	maxWidth: 264,
	marginRight: 0,
	marginBottom: last ? 0 : 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 30,
		marginBottom: 0,
		justifyContent: 'space-between',
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	width: 264,
	marginBottom: 30,
	aspectRatio: '240/180',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))
